import React from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import Navigation from "components/Navigation";
import Header from "components/Header";
import Home from "components/Home/";
import Imprint from "components/Imprint/";
import Privacy from "components/Privacy/";
import Footer from "components/Footer";
import ErrorHandler from "components/ErrorHandler";

export class RouterMain extends React.Component {
  render() {
    return (
      <main>
        <Switch>
          <Route
            exact={true}
            strict={true}
            path="/:url*"
            render={props => <Redirect to={`${props.location.pathname}`} />}
          />
          <Route exact={true} path="/" component={Home} />
          <Route exact={true} path="/referenzen" component={Home} />
          <Route exact={true} path="/was-wir-koennen" component={Home} />
          <Route exact={true} path="/kontakt" component={Home} />
          <Route exact={true} path="/datenschutz" component={Privacy} />
          <Route exact={true} path="/impressum" component={Imprint} />
          <Route component={ErrorHandler} />
        </Switch>
      </main>
    );
  }
}

export class RouterNavigation extends React.Component {
  render() {
    return (
      <nav>
        <Switch>
          <Route
            exact={true}
            path="/"
            render={() => <Navigation isHome={true} />}
          />
          <Route exact={true} path="/datenschutz" component={Navigation} />
          <Route exact={true} path="/impressum" component={Navigation} />
          <Route />
        </Switch>
      </nav>
    );
  }
}

export class RouterHeader extends React.Component {
  render() {
    return (
      <header>
        <Switch>
          <Route exact={true} path="/" component={Header} />
          <Route
            exact={true}
            path="/datenschutz"
            render={() => <Header isSmallHeader={true} />}
          />
          <Route
            exact={true}
            path="/impressum"
            render={() => <Header isSmallHeader={true} />}
          />
        </Switch>
      </header>
    );
  }
}

export class RouterFooter extends React.Component {
  render() {
    return (
      <footer>
        <Switch>
          <Route path="/" component={Footer} />
        </Switch>
      </footer>
    );
  }
}

export default RouterMain;



// WEBPACK FOOTER //
// ./src/Router.js